<template>
  <div class="faq">
    <ui-title>{{ t('docs.faq.title') }}</ui-title>
    <div class="container">
      <div class="faq__wrapper">
        <el-collapse v-model="collapse">
          <el-collapse-item
              v-for="(el, idx) of faq"
              :key="idx"
              :title="t(`docs.faq.content[${idx}].title`)"
              :name="idx + 1"
          >
            <i18n-t tag="p" scope="global" :keypath="`docs.faq.content[${idx}].text`">
              <template #email>
                <a class="faq__link" :href="'mailto:' + companyInfo.emailFrom">{{ companyInfo.emailFrom }}</a>
              </template>
            </i18n-t>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script setup>
import UiTitle from "@/components/ui/ui-title.vue";
import {useI18n} from "vue-i18n";
import enGB from '@/locales/en-gb.json'
import {computed, ref} from "vue";
import translations from "@/core/helpers/translations.js";
import {useCompanyStore} from "@/stores/company.js";

const {t} = useI18n()
const companyStore = useCompanyStore()

const companyInfo = computed(() => {
  return companyStore.companyInfo ? companyStore.companyInfo : null
})

const faq = ref(enGB.docs.faq.content)
const collapse = ref([])
</script>

<style lang="scss" scoped>
.faq {
  &__wrapper {
    padding-top: 100px;
  }

  &__link {
    color: #FF6162;
    transition: 0.2s;

    @include hover {
      color: #fd4445;
    }
  }
}

:deep(.el-collapse) {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 100px;
  border: none;
}
:deep(.el-collapse-item__header) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  background-color: $white;
  box-shadow: 0 0 30px 0 rgba(209, 209, 209, 0.25);
  padding: 15px 20px;
  height: unset;
  border: none;
  transition: 0.5s;

  color: #2F2F2F;
  font-family: Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
}
:deep(.el-collapse-item__header.is-active) {
  border-radius: 10px 10px 0 0;
}
:deep(.el-collapse-item__wrap) {
  border-bottom: unset;
  padding-inline: 20px;
  border-radius: 0 0 10px 10px;
}
:deep(.el-collapse-item__content) {
  padding-bottom: 0;
  padding-block: 20px;

  color: #2F2F2F;
  text-align: justify;
  font-size: 16px;
  font-weight: 400;
  line-height: 25px;
}

@media (max-width: 550px) {
  :deep(.el-collapse-item__header) {
    font-size: 14px;
  }
  :deep(.el-collapse-item__content) {
    font-size: 12px;
    line-height: 16px;
  }
}
</style>